// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"X8-z"};